import './auth/spotifyOAuthCallback';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import {
  RouterProvider
} from "react-router-dom";
import Notification from './components/Notifications/Notification';
import './index.css';
import reportWebVitals from './reportWebVitals';
import router from './Router';
import { store } from './stores/store';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from './stores/store';
import { initializeAnalytics } from './analytics/mixpanel';
import { initializeGoogleAnalytics } from './analytics/googleAnalytics';
import { withoutPasteId } from './analytics/productAnalytics';
initializeAnalytics();
initializeGoogleAnalytics();

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* MUI loads with the Cartinese pages, which bring their own theme (CartiScope).
            Its global baseline styles live in index.css, so the shell stays out of MUI. */}
        <div className="dark min-h-screen">
          <Notification />
          <RouterProvider router={router} />
        </div>
        <SpeedInsights beforeSend={withoutPasteId} />
        <Analytics beforeSend={withoutPasteId} />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
